// 第三方库
import React from 'react';
import { Layout, Menu, theme, Button } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

// 内部模块 - Store
import { accountStore } from '../store/AccountStore';
import { tokenDebugStore } from '../store/TokenDebugStore';

// 内部模块 - Hooks
import { useUserInfo } from '../hooks/useUserInfo';

// 内部模块 - 组件
import TokenDebugPanel from '../components/TokenDebugPanel';

// 内部模块 - 资源
import Logo from '../assets/logo.png';

// 内部模块 - 图标
import {
  MessageOutlined,
  ApiOutlined,
  QrcodeOutlined,
  RobotOutlined,
  BookOutlined,
  SendOutlined,
  BugOutlined,
} from '@ant-design/icons';

// 内部模块 - 常量
import { APP_NAME, COMPANY_NAME } from '@/constants/constants';

// 内部模块 - 样式
import './SiderLayout.less';

const { Header, Content, Footer, Sider } = Layout;

const SiderLayout = observer(() => {
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useUserInfo();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const menuItems = [
    {
      key: 'message',
      icon: <MessageOutlined />,
      label: '在线聊天',
    },
    {
      key: 'automation',
      icon: <RobotOutlined />,
      label: '自动化流程',
    },
    {
      key: 'script-library',
      icon: <BookOutlined />,
      label: '话术库',
    },
    {
      key: 'batch-task',
      icon: <SendOutlined />,
      label: '消息群发',
    },
    {
      key: 'integration',
      icon: <ApiOutlined />,
      label: '集成',
    },
    {
      key: 'import-codes',
      icon: <QrcodeOutlined />,
      label: '二维码生成',
    },
  ];

  // 获取当前路由的标题
  const getPageTitle = pathname => {
    const route = menuItems.find(item => pathname.startsWith(`/${item.key}`));
    return route?.label || '';
  };

  // 获取当前选中的菜单项
  const getSelectedKeys = pathname => {
    const selectedItem = menuItems.find(item => pathname.startsWith(`/${item.key}`));
    return selectedItem ? [selectedItem.key] : [];
  };

  const handleLogout = () => {
    accountStore.logout();
    navigate('/user/login');
  };

  const handleMenuClick = ({ key }) => {
    // 如果是service路由，重定向到message路由
    if (key === 'service') {
      navigate('/message');
    } else {
      navigate(key);
    }
  };

  return (
    <Layout hasSider className='layout-container'>
      <Sider className='sider'>
        <div className='logo'>
          <img alt='logo' src={Logo} />
          <span>{APP_NAME}</span>
        </div>
        <Menu
          theme='dark'
          mode='inline'
          selectedKeys={getSelectedKeys(location.pathname)}
          items={menuItems}
          onClick={handleMenuClick}
        />
      </Sider>
      <Layout>
        <Header className='header' style={{ background: colorBgContainer }}>
          <div className='page-title'>{getPageTitle(location.pathname)}</div>
          <div className='header-right'>
            <span className='username'>{userInfo?.name}</span>
            <Button
              type='text'
              className='hidden'
              icon={<BugOutlined />}
              onClick={() => tokenDebugStore.show()}
              size='small'
            >
              调试
            </Button>
            <Button type='link' onClick={handleLogout}>
              退出登录
            </Button>
          </div>
        </Header>
        <Content className='content'>
          <Outlet />
        </Content>
        <Footer className='footer'>
          {COMPANY_NAME} ©{new Date().getFullYear()}
        </Footer>
      </Layout>

      {/* Token 调试面板 */}
      <TokenDebugPanel />
    </Layout>
  );
});

export default SiderLayout;
